import React from "react";
import { Image } from "react-bootstrap";
import { PageHeader } from "CommonComponent";

const Header = ({ onAddClick, canAdd = false }) => {
  return (
    <PageHeader title="All Sections">
      {canAdd ? (
        <button type="button" className="add-new-btn" onClick={onAddClick}>
          <Image src="/assets/images/add-icon.svg" className="me-2" alt="" aria-hidden="true" />
          Add New
        </button>
      ) : null}
    </PageHeader>
  );
};

export default Header;
